import Chip from '@mui/material/Chip';
export default Chip;
export * from '@mui/material/Chip';
